import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { updateCaseType } from '../actions/form';
import { getCaseType, getErrors } from '../reducers/form';
import cx from 'classnames';
import Dropdown from 'common/components/Dropdown';

const mapStateToProps = state => ({
  caseType: getCaseType(state),
  errors: getErrors(state),
});
const mapDispatchToProps = dispatch => ({
  updateCaseType: caseType => dispatch(updateCaseType(caseType)),
});

const CaseType = ({ caseType, updateCaseType, errors }) => {
  const fieldClass = cx('field required', {
    error: errors.includes('caseType'),
  });

  const typeOptions = [
    {
      text: 'Chantier concurrent',
      value: 'CONCURRENT',
    },
    {
      text: 'Chantier historique',
      value: 'EXISTING',
    },
    {
      text: 'Chantier HD',
      value: 'HD',
    },
  ];

  const renderDefault = () => {
    const selectedValue = typeOptions.find(r => r.value === caseType);
    if (selectedValue) {
      return <div className="text">{selectedValue.text}</div>;
    }
    return <div className="default text">Type du chantier</div>;
  };

  const itemClassName = value => {
    const active = caseType === value;
    return cx('item', {
      active: active,
      selected: active,
    });
  };

  const renderItem = item => (
    <div
      key={item.value}
      data-value={item.value}
      className={itemClassName(item.value)}
    >
      {item.text}
    </div>
  );

  const onDropdownChange = (value, text, choice) => {
    updateCaseType(value);
  };

  return (
    <div className="ui segment">
      <div className="two fields">
        <div className={fieldClass}>
          <label>Quel est le type de votre chantier?</label>
          <Dropdown
            name="type"
            value={caseType}
            items={typeOptions}
            renderDefault={renderDefault}
            renderItem={renderItem}
            onChange={onDropdownChange}
          />
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

CaseType.propTypes = {
  caseType: PropTypes.string.isRequired,
  updateCaseType: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseType);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/CaseType.js